export const studentsListIntroSteps = [
  {
    element: '.report-section-header',
    intro: 'The Student List is where you can view your whole WordFlight roster. You can add, edit, and delete students on this page.'
  },
  {
    element: 'wf-students-filter',
    intro: 'Use these filters to narrow down the students by grade or class.'
  },
  {
    element: '#print-button',
    intro: 'Click here to print the student list.'
  },
  {
    element: '#addButton',
    intro: 'Click here to add new students to your WordFlight roster.'
  },
  {
    element: '#addCleverSections',
    intro: 'Click here to add Clever sections to your WordFlight roster.'
  },
  {
    element: '#addClassLinkSections',
    intro: 'Click here to add ClassLink sections to your WordFlight roster.'
  },
  {
    element: '#deleteButton',
    intro: 'Click here to archive the selected student from your account. The student’s data will also be archived.'
  },
  {
    element: 'table.report-table tbody tr:first-child button[title="Edit Student"]',
    intro: 'Click here to edit your student’s account and settings. This allows you to edit the student’s name, username, password, grade, class, session time, and in program settings.'
  },
];